import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SendFax from "./SendFax";
import SpinnerCircles from './Spinner/SpinerCircles';

const SendFaxModal = ({ isOpen, onConfirm, onCancel, onSendFax, loading }) => {
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>New Fax</ModalHeader>
        <ModalBody>
          <SendFax />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>Cancel</Button>
          {loading ? <SpinnerCircles red />
            :
            <Button color="primary" onClick={onConfirm}>Send</Button>}
        </ModalFooter>
      </Modal>
    )
};

export default SendFaxModal;